import r from '../Utils/fetch';

const w: any = window;
const endPoint = `${w.API_CORE_URL}`;

const endPoints = {
	users: `${endPoint}/v1/users`,
	beta: `${endPoint}/v1/beta-testers`,
};

export const subscriptionStatusChoices = [
	{ id: 0, name: 'En attente' },
	{ id: 100, name: 'Refusé' },
	{ id: 200, name: 'Accepté' },
];

export const roleChoices = [
	{ id: 'ROLE_ADMIN', name: 'Admin' },
	{ id: 'ROLE_SALES', name: 'Sales' },
	{ id: 'ROLE_USER', name: 'User' },
	{ id: 'ROLE_GUEST', name: 'Guest' }, // Ajouter d'autres rôles si nécessaire
];

export interface User {
	id: number;
	name: string;
	phone: string;
	email: string;
	subscriptionStatus: number;
	roles: string[];
	createdAt?: Date;
	twoFAMethod: 'app' | 'webauthn' | null; // Méthode 2FA
}

interface ITake {
	token: string;
}
export interface UserPayload extends Omit<User, 'id'> {}

export const getMe = (): Promise<{ user: User }> =>
	r({ url: `${endPoints.users}/me`, method: 'GET' });

export const getMyQr2FaCode = (): Promise<any> =>
	r({ url: `${endPoints.users}/2fa/totp/qrcode`, method: 'GET' });

export const validate2FACode = (code: string): Promise<any> =>
	r({
		url: `${endPoints.users}/2fa/totp/validate?code=${code}`,
		method: 'GET',
	});

export const getWebAuthnFaCode = (): Promise<{
	publicKey: PublicKeyCredentialCreationOptions;
}> =>
	r({
		url: `${endPoints.users}/2fa/webauthn/register/challenge`,
		method: 'GET',
	});

export const postWebAuthnFaCode = (data: any): Promise<any> =>
	r({
		url: `${endPoints.users}/2fa/webauthn/register/complete`,
		method: 'POST',
		data,
	});

export const postWebAuthnFaLoginChallenge = (): Promise<any> =>
	r({
		url: `${endPoints.users}/2fa/webauthn/login/challenge`,
		method: 'GET',
	});

export const postWebAuthnFaLoginComplete = (data: any): Promise<any> =>
	r({
		url: `${endPoints.users}/2fa/webauthn/login/complete`,
		method: 'POST',
		data,
	});

export const take = (fb_uuid: string): Promise<ITake> =>
	r({
		url: `${endPoint}/v1/admin/users/take`,
		method: 'GET',
		data: { fbUuid: fb_uuid },
	});

export const valideEmail = (fb_uuid: string): Promise<any> =>
	r({
		url: `${endPoint}/v1/admin/users/valid-email`,
		method: 'GET',
		data: { fbUuid: fb_uuid },
	});
